import { useEffect, useState } from 'react';
import { useOnline } from '../lib/net';
import { uploadQueue } from '../lib/portal';

/** Amber offline banner (AP-16): write-lock notice + queued-upload count + reconnect flush. */
export default function OfflineBanner() {
  const online = useOnline();
  const [pending, setPending] = useState(0);

  useEffect(() => {
    let alive = true;
    const poll = () => uploadQueue.pending().then((n) => alive && setPending(n));
    poll();
    const t = setInterval(poll, 4000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, [online]);

  if (online && pending === 0) return null;
  return (
    <div className={online ? 'netbanner syncing' : 'netbanner offline'} role="status">
      {online
        ? `Back online — syncing ${pending} queued upload${pending === 1 ? '' : 's'}…`
        : 'You are offline. Your work is saved on this device and uploads will resume automatically.'}
    </div>
  );
}
